// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'

// Modal for car features list
import VueModal from 'vue-js-modal'
Vue.use(VueModal, { dynamic: true, injectModalsContainer: true })

// dependencies from DesignSystem
import scrollto from 'vue-scrollto'
Vue.use(scrollto)

const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr')
// import VueAwesomeSwiper from 'vue-awesome-swiper'

// require styles
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import DesignSystem from 'moqo-design-system'
import 'moqo-design-system/dist/system/system.css'
Vue.use(DesignSystem)

// import SvgIcon from 'moqo-design-system/src/utils/_SvgIcon.vue'
// Vue.component('svg-icon', SvgIcon)

Vue.config.productionTip = false

import eventBus from '@/lib/bus'
Vue.use(eventBus)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import i18nSettings from '@/lib/i18n.js'
const i18n = new VueI18n(i18nSettings)

require('es6-promise').polyfill()

// shortcut to register all components globally
import AllComponents from '@/lib/require_all_components.js'
AllComponents.require()

import SimpleModal from '@/lib/modal'
Vue.mixin(SimpleModal)

Vue.mixin({
  computed: {
    signupBtnText () {
      if (!this.teamsiteConfig.has_signup_fee && !this.teamsiteConfig.has_any_sign_up_mandants_with_signup_fee) {
        return this.$t('teamsite.call_to_action.free_registration_btn')
      }
      return this.$t('teamsite.call_to_action.registration_btn')
    },

    generalBusinessTermsDocument () {
      if (!this.teamsiteConfig.provider.legal_documents) return null

      return this.teamsiteConfig.provider.legal_documents.find(
        document => document.kind == 'general_business_terms'
      )
    },

    isBikeOnly() {
      if (!this.teamsiteConfig || !this.teamsiteConfig.cars.length) { return false }

      for(let index in this.teamsiteConfig.cars) {
        let car = this.teamsiteConfig.cars[index]
        if (car.car_type != "bike") {
          return false
        }
      }
      return true
    },

    isFreeForAll() {
      if (!this.teamsiteConfig || !this.teamsiteConfig.cars.length) { return false }

      for(let index in this.teamsiteConfig.cars) {
        let car = this.teamsiteConfig.cars[index]
        if (car.tariff) {
          return false
        }
      }
      return true
    }
  },

  methods: {
    vehicleString(car, bike) {
      if (this.isBikeOnly) { return bike }
      return car
    },

    addTrackingDataToRegisterButton(options) {
      const {element, ...additionalOptions} = options

      if (!element) return

      element.classList.add('register_button')
      element.setAttribute('data-provider', this.teamsiteConfig.provider.id)
      element.setAttribute('data-team', this.teamsiteConfig.id)

      for (let [key, value] of Object.entries(additionalOptions)) {
        element.setAttribute(`data-${key}`, value)
      }
    },
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js